<template>
  <div class="text-center">
    <px-lateral-dialog v-model="dialog" width="600">
      <template v-slot:activator="{ on }">
        <v-btn class="rounded-tag-small normal-btn-text elevation-0" v-on="{...on }">
          <v-icon>mdi-account-multiple-check-outline</v-icon>
          <span class="pa-4">
            Grupos de fornecedores
          </span>
        </v-btn>
      </template>
      <template v-slot:title>
        Seleção de grupos de fornecedores
      </template>
      <template>
        <v-autocomplete
          outlined
          hide-details
          clearable
          return-object
          hide-selected
          hide-no-data
          no-filter
          multiple
          chips
          small-chips
          deletable-chips
          item-value="id"
          item-text="descricao"
          label="Grupos de Fornecedores"
          class="pa-5 rounded-tag-small required"
          v-model="localValue"
          :items="items"
          :loading="loading"
          :search-input.sync="search"
          @blur="onBlur"
          @change="onChange"
          @focus="onFocus"
          :error="$v.localValue.$error"
          v-bind="$attrs"
        >
          <template v-slot:item="item">
            <slot name="item" v-bind:item="item">
              <v-list-item-content>
                <v-list-item-title v-text="item.item.descricao"/>
              </v-list-item-content>
            </slot>
          </template>
          <template v-slot:selection="item">
            <div class="truncate-text">
              {{ item.item.descricao }}
              <v-btn small icon @click="onRemoveItem(item.index)">
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </div>
          </template>
        </v-autocomplete>
      </template>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn color="primary"
          class="normal-btn-text rounded-tag-small elevation-0"
          @click="onIncluirFornecedores">
          Incluir fornecedores
        </v-btn>
        <v-btn text class="normal-btn-text" @click="onClose">
          Fechar
        </v-btn>
      </template>
    </px-lateral-dialog>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';
import { debounce } from 'vuetify/lib/util/helpers';
import FornecedorGrupoService from '@/api/fornecedor-grupo-service';

const DEFAULT_LIMIT = 15;
const DEFAULT_OFFSET = 0;

export default {
  mixins: [validationMixin],
  props: {
    value: Array,
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
      dialog: false,
    };
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  watch: {
    search(val) {
      if (!val || (this.localValue && this.localValue.descricao === val)) return;
      this.debounceSearch(val);
    },
  },
  methods: {
    buildFilter(val) {
      const text = val || '';
      return `descricao like "%${text.toLowerCase()}%" order by descricao`;
    },
    searchFornecedores(val) {
      this.loading = true;

      FornecedorGrupoService.getFornecedorGrupo({
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query: this.buildFilter(val),
      })
        .then((response) => {
          this.items = response.data.content ? response.data.content : response.data;
          if (this.value && this.value.length) {
            this.items = [...this.items, ...this.value];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onChange(event) {
      this.$emit('change', event);
    },
    onFocus() {
    },
    onRemoveItem(index) {
      this.localValue.splice(index, 1);
      this.$emit('input', this.localValue);
    },
    onIncluirFornecedores() {
      if (this.validateForm()) {
        return;
      }
      this.$emit('incluir-fornecedores');
      this.onClose();
    },
    onClose() {
      this.localValue = null;
      this.items = [];
      this.search = null;
      this.dialog = false;
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchFornecedores, 1000);
    if (this.value && this.value.length) {
      this.items = [...this.items, ...this.value];
    }
  },
  validations: {
    localValue: {
      required,
    },
  },
};
</script>
